
    var riot = require('riot')
    import { LazyImage } from './gb-lazy-image';
riot.tag2('gb-lazy-image', '<img class="gb-lazy-image" ref="lazyImage" src="//placehold.it/300x300">', 'gb-lazy-image img.gb-lazy-image,[data-is="gb-lazy-image"] img.gb-lazy-image{ width: 300px; height: 300px; }', '', function(opts) {
    this._mixin(LazyImage);
});

    
  


// WEBPACK FOOTER //
// ./src/tags/lazy-image/gb-lazy-image.tag.html